<div *ngIf="file$ | async as file" class="content-container">
  <dgx-pdf-viewer *ngIf="file.type?.includes('pdf')" [fileUrl]="file.url">
  </dgx-pdf-viewer>
  <dgx-video-viewer *ngIf="inputType === 'Video'" [input]="input">
  </dgx-video-viewer>
</div>
